import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Scroll } from '../atoms/page-scroll'
import { Body } from '../molecules/body'
import { TemplateProps } from '../type'

export const TemplateMobile: React.FC<TemplateProps> = ({
	onScroll,
	...props
}) => {
	return (
		<Scroll {...props} close={props.close} onScroll={onScroll}>
			<WrapperMobile isFullScreen={props?.mobile?.isFullScreen}>
				<Body {...props} />
			</WrapperMobile>
		</Scroll>
	)
}

const WrapperMobile = styled.div<{ isFullScreen?: boolean }>`
	width: 100%;
	display: flex;
	flex-flow: column;
	height: ${({ isFullScreen }) => (isFullScreen ? '100%' : 'auto')};
	margin-top: ${({ isFullScreen }) => (isFullScreen ? '0' : '30px')};
`
